<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-center">Dedication</p>
<p class="para-center">Dedicated to my mother and father for their extraordinary love and support</p>
<p class="para-center">In memory of Marshall T. Meyer whose spirituality touched so many lives</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780025492659f01.vue?6ec3f0ee